import {$regraAcao, $regraEntidade} from "@/custom-enum/regras-enum";

export default [
    {
        path: '/cadastrar-bi',
        name: 'novos-bi',
        meta: {
            resource: $regraEntidade.rotas.protegida,
            subject: $regraEntidade.menuLateral.relatorios.relatorio,
            action: $regraAcao.visualizar,
            layout: 'normal',
            title: 'Cadastro de BI'
        },
        component: () => import ('@/views/pages/relatorios/CadastrarBI.vue')
    },
    {
        path: '/listagem-bi',
        name: 'listagem-bi',
        meta: {
            resource: $regraEntidade.rotas.protegida,
            subject: $regraEntidade.menuLateral.relatorios.relatorio,
            action: $regraAcao.visualizar,
            layout: 'normal',
            title: 'Editar BI'
        },
        component: () => import ('@/views/pages/relatorios/ListagemBI.vue')
    }
]
